import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

/**
 * AuthCallback - Handles Google OAuth callback
 * Processes session_id from URL fragment and exchanges it for user session
 */
const AuthCallback = ({ onLogin }) => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      // Extract session_id from URL fragment (hash)
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        console.error('No session_id found in callback URL');
        toast.error('Error de autenticación: No se encontró la sesión');
        navigate('/login');
        return;
      }

      try {
        // Exchange session_id for user session via backend
        const response = await axios.post('/auth/google/session', {
          session_id: sessionId
        });

        const { user } = response.data;
        
        // Clear the URL fragment
        window.history.replaceState(null, '', window.location.pathname);
        
        // Call onLogin with user data
        onLogin(user);
        
        toast.success(`¡Bienvenido, ${user.name}!`);
        
        // Navigate to dashboard
        navigate('/', { replace: true });
      } catch (error) {
        console.error('Google auth error:', error);
        const errorMessage = error.response?.data?.detail || 'Error al autenticar con Google';
        toast.error(errorMessage);
        navigate('/login');
      }
    };

    processCallback();
  }, [navigate, onLogin]);

  return (
    <div 
      className="min-h-screen flex items-center justify-center" 
      style={{ backgroundColor: '#EAE0D5' }}
      data-testid="auth-callback-loading"
    >
      <div className="text-center space-y-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#224049] mx-auto"></div>
        <p className="text-lg" style={{ color: '#224049' }}>
          Autenticando con Google...
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
